import { render, staticRenderFns } from "./SchoolArea.vue?vue&type=template&id=9f5dd454&scoped=true"
import script from "./SchoolArea.vue?vue&type=script&lang=js"
export * from "./SchoolArea.vue?vue&type=script&lang=js"
import style0 from "./SchoolArea.vue?vue&type=style&index=0&id=9f5dd454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5dd454",
  null
  
)

export default component.exports